/**
 * Author Card
 * @module AuthorCard
 */
export default class AuthorCard {
	private cardContent: HTMLElement | null
	private cardContentText: HTMLElement | null
	private ctaMore: HTMLElement | null

	/**
	 * Constructor
	 * @param {HTMLElement} element - HTML element
	 */
	constructor(element: HTMLElement) {
		this.cardContent = element.querySelector('.authorCard-content')
		this.cardContentText = element.querySelector('.authorCard-contentText')
		this.ctaMore = element.querySelector('.authorCard [data-cta-more]')
		this.onClickOnCtaMore = this.onClickOnCtaMore.bind(this)
	}

	/**
	 * Checks for the presence of a specific attribute and adds events and a CSS class
	 */
	init() {
		if (this.ctaMore) {
			if (this.isDescriptionHidden()) {
				this.addEvents()
			} else {
				this.ctaMore.classList.add('hidden')
			}
		}
	}

	/**
	 * The function checks if the content text in a card is overflowing its container.
	 * @returns The `isDescriptionHidden()` function will return `true` if the description
	 * is hidden, and `false` if it is
	 */
	isDescriptionHidden() {
		if (this.cardContentText) {
			return this.cardContentText.scrollHeight > this.cardContentText.clientHeight
		}
	}

	/**
	 * The `addEvents` function adds a click event listener to the `ctaMore` element.
	 */
	addEvents() {
		;(this.ctaMore as HTMLElement).addEventListener('click', this.onClickOnCtaMore)
	}

	/**
	 * The `onClickOnCtaMore` function prevents the default event behavior and toggles the 'isOpen' class
	 * on the card content element.
	 * @param {Event} event - Information about the event
	 * target element
	 */
	onClickOnCtaMore(event: Event) {
		event.preventDefault()
		this.cardContent?.classList.toggle('isOpen')
	}
}
